import { ScrollView } from 'react-native';
import { Flex } from '@banhala/ui-kit';
import { IconShortcut } from 'shared/src/component';
import type { IconSummary } from 'shared/src/api';
import { useOpenDeeplink } from 'shared/src/hooks';
import { useLogClickShortcut } from '../../../hooks/useLogClickShortcut';

interface IconSummaryListProps {
  icons: IconSummary[];
}

export const IconSummaryList = ({ icons }: IconSummaryListProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const logClickShortcut = useLogClickShortcut();

  const handlePress = (icon: IconSummary) => {
    logClickShortcut(icon);
    openDeeplink(icon.item.deeplink);
  };

  return (
    <Flex
      backgroundColor="white"
      borderBottomWidth={1}
      borderColor="border_tertiary"
    >
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{
          gap: 6,
          paddingTop: 8,
          paddingBottom: 16,
          paddingHorizontal: 12,
        }}
      >
        {icons.map(icon => (
          <IconShortcut
            key={icon.item.name}
            imageUri={icon.item.representative_image}
            name={icon.item.name}
            onPress={() => handlePress(icon)}
          />
        ))}
      </ScrollView>
    </Flex>
  );
};
